module.exports = __webpack_public_path__ + "img/a1.cbbcf9f8.jpg";